<template>
  <div class="page">
  <div class="page-content">
      <el-tabs v-model="activeName" type="card">
          <el-tab-pane :label="item.placeName" :name="item.id" v-for="(item,index) in placeIdList"></el-tab-pane>
      </el-tabs>
      <div class="content">
          <div v-for="(item,index) in modelRewardList" :key="index" class="item">
              <div class="top">
                  <MgJzD :typeId="item.dictType" style="margin-left: 3px;"></MgJzD>
                  <span
                      class="icon-box"
                      :title="'安置奖励介绍：' + item.rewardIntro"
                      style="margin-left: 8px;cursor: pointer"
                  >
<!--                      <Icon color="#606266">-->
                      <!--                        <Refresh />-->
                      <!--                      </Icon>-->
                      <i class="el-icon-info" style="color: #606266;"></i>
                    </span>
              </div>
              <div class="center">
<!--                  <i class="el-icon-question" style="width: 42px;height: 42px;font-size: 42px;margin-right: 8px;color: #2d8cf0"></i>-->
                  <span>
                      {{item.rewardName}}
                  </span>
              </div>
              <div class="bottom">
                  <el-switch
                      v-model="item.isActive"
                      active-color="#13ce66"
                      :active-value="1"
                      :inactive-value="0"
                      inactive-color="#ff4949">
                  </el-switch>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlaceUI.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
    computed:{
      newEumn(){
        return this[`auditStatus${this.emap}`];
      },
      newEumns(){
        return this[`auditStatus${this.emaps}`];
      },
    names() {
        return this.modelRewardList.map(item => item.isActive);
    },
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelRewardList();
                    this.getModelRewardList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelRewardList();
                    this.getModelRewardList();
                    this.$emit('resetCheckState');
                }
            },
            'modelReward.placeId':{
                handler(val,old) {
                    if (val == old || val == null || val == '' || val == undefined) {
                        return;
                    }
                    for (const iterator of this.placeIdList) {
                      if(iterator.id == val){
                        this.emap = iterator.placeType;
                      }
                    }
                    // 一会儿return
                },
            },
            'queryForm.placeId':{
                handler(val,old) {
                    if (val == old || val == null || val == '' || val == undefined) {
                        return;
                    }
                    for (const iterator of this.placeIdList) {
                      if(iterator.id == val){
                        this.emaps = iterator.placeType;
                      }
                    }
                    // 一会儿return
                },
            },
            activeName:{
                handler(val,old) {
                    if (val === old) {
                        return;
                    }
                    this.modelRewardList = []
                    this.queryForm.placeId = val;
                    this.getModelRewardList();
                    console.log(val);
                },
            },
            names: {
                handler(newNames, oldNames) {
                    if(JSON.stringify(oldNames) == '[]'){
                        return
                    }
                    newNames.forEach((name, index) => {
                        if (name !== oldNames[index]) {
                            console.log(`Active of item at index ${index} changed to ${name}`);
                            post(`/model/rewardplace/edit`,this.modelRewardList[index] ).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelRewardList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                    this.modelRewardList[index].isActive = oldNames[index];
                                }
                            });
                        }
                    });
                },
                deep: true,
                immediate: false,
            },
        },

    data() {
            return {
                emaps: "",
                queryForm:{
                     rewardName: '', //奖励名称
                     rewardType: '', //奖励类型
                     placeId: '', //安置ID
                     isActive: '', //是否激活
                     rewardIntro: '', //奖励介绍
                     dictType: '', //字典类型
                },
                activeName: null,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelRewardState: 'add',
                modelRewardStates: {
                    add: '新建奖励',
                    check: '查看奖励',
                    edit: '修改奖励'
                },
                emap: '',
                multipleSelection: [],
                modelRewardList: [],
                modelReward: {
                    id: '', //ID
                    rewardName: '', //奖励名称
                    rewardType: '', //奖励类型
                    placeId: '', //安置ID
                    isActive: '', //是否激活
                    rewardIntro: '', //奖励介绍
                    dictType: '', //字典类型
                    createTime: '', //
                    obtainCondition: ''
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    rewardName: [{ required: true, message: '奖励名称不能为空', trigger: 'blur' }],
                    rewardType: [{ required: true, message: '奖励类型不能为空', trigger: 'blur' }],
                    placeId: [{ required: true, message: '安置ID不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    rewardIntro: [{ required: true, message: '奖励介绍不能为空', trigger: 'blur' }],
                    dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    obtainCondition: [{ required: true, message: '获取条件不能为空', trigger: 'blur' }],
                },
                placeIdList:[],
                auditStatus1:[],
                auditStatus2:[],
                auditStatus3:[],
                auditStatus4:[],
                auditStatus5:[],
                auditStatus6:[],
                auditStatus7:[],
                auditStatus8:[],
            };
        },
        created() {
            this.getplaceIdList();
            this.getEnums();
        },
        mounted() {
            // this.getModelRewardList();
        },
        methods: {
            getplaceIdList(){
                get('/model/place/findAll').then(res => {
                    this.placeIdList = res.list;
                    this.activeName = this.placeIdList[0].id;
                    this.queryForm.placeId = this.placeIdList[0].id;
                    this.getModelRewardList();
                });
            },
            handleClick(tab, event) {
                console.log(tab, event);
            },
            returnPlaceIdList(key){
                for (const iterator of this.placeIdList) {
                  if(key == iterator.id){
                    return iterator.placeName;
                  }
                }
            },
            getEnums(){
              for(let i = 1;i<=7;i++){
                get('/mpp/utils/getEnum', { enumType: `model_place${i}_reward_type` }).then((res) => {
                  this[`auditStatus${i}`] = res.enumList;
                });
              }
              get('/mpp/utils/getEnum', { enumType: `model_recommend_reward_type` }).then((res) => {
                  this.auditStatus8 = res.enumList;
                });
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetModelRewardList() {
                // this.pageSize = 10;
                // this.currentPage = 1;
                this.modelRewardList = [];
            },
            resetDialog() {
                this.modelRewardState = 'add';
                this.showDialog = false;
                // this.queryForm = {
                //       id: '', //ID
                //       rewardName: '', //奖励名称
                //       rewardType: '', //奖励类型
                //       placeId: '', //安置ID
                //       isActive: '', //是否激活
                //       rewardIntro: '', //奖励介绍
                //       dictType: '', //字典类型
                //       createUserId: '', //
                //       createTime: '', //
                //       updateUserId: '', //
                //       updateTime: '', //
                //       deleteFlag: '', //
                // };
                this.getModelRewardList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelReward = {
                      id: '', //ID
                      rewardName: '', //奖励名称
                      rewardType: '', //奖励类型
                      placeId: '', //安置ID
                      isActive: '', //是否激活
                      rewardIntro: '', //奖励介绍
                      dictType: '', //字典类型
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                      obtainCondition: ''
                };
            },
            submitForm() {
                if (this.modelRewardState == 'add') {
                    this.$refs.modelRewardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/rewardplace/add`,{ ...this.modelReward }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelRewardList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelRewardState == 'edit') {
                    this.$refs.modelRewardForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/rewardplace/edit`,{ ...this.modelReward }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelRewardList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelReward() {
                this.showDialog = true;
                this.modelRewardState = 'add';
            },
            checkModelReward(modelRewardId) {
                console.log(modelRewardId);
                this.currentModelRewardId = modelRewardId;

                this.getModelRewardById();
                this.showDialog = true;
                this.modelRewardState = 'check';
            },
            editModelReward(modelRewardId) {
                console.log('modelReward', modelRewardId);
                if (modelRewardId) {
                    this.currentModelRewardId = modelRewardId;
                    this.getModelRewardById();
                } else {
                    this.modelReward = { ...this.modelReward, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelRewardState = 'edit';
            },
            deleteModelReward(modelRewardId) {
                let ids = '';
                if (modelRewardId) {
                    ids = modelRewardId;
                } else {
                    ids = this.multipleSelection.map((modelReward) => modelReward.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/rewardplace/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelRewardList();
                                this.getModelRewardList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelRewardList() {
                this.resetModelRewardList();
                this.getModelRewardList();
            },
            getModelRewardList(query = {}) {
                this.loading = true;
                get(`/model/rewardplace/findAll`,{  ...this.queryForm }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelRewardList = res.list;
                        console.log(this.modelRewardList)
                        // this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelRewardById() {
                get(`/model/rewardplace/get`,{ id: this.currentModelRewardId }).then((res) =>{
                    if(res.success){
                      this.modelReward = { ...this.modelReward, ...res.modelReward };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelRewardList() {
                //this.btnLoading = true;
                exprotExcel(`/model/rewardplace/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/rewardplace/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/rewardplace/importData`,formData);
              this.refreshModelRewardList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelRewardList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelRewardList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.content{
     display: flex;
     flex-wrap: wrap;
     width: 100%;
     height: auto;
     .item{
         width: 180px;
         height: 120px;
         box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
         border-radius: 8px;
         padding: 10px;
         margin-left: 15px;
         margin-bottom: 15px;
         .top{
             display: flex;
             justify-content: flex-end;
             align-content: center;
             align-items: center;
         }
         .center{
             margin-top: 4px;
             height: 42px;
             display: flex;
             span{
                 display: -webkit-box;
                 -webkit-line-clamp: 2;
                 -webkit-box-orient: vertical;
                 overflow: hidden;
                 font-size: 14px;
             }
         }
         .bottom{
             margin-top: 4px;
             display: flex;
             justify-content: flex-end;
         }
     }
 }
</style>